// extracted by css-extract-rspack-plugin
export default {"list":"SnWNnLA___list","item":"wMl9qGw___item"};